import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import {
  ResourcesContainer,
  Wrapper,
  CategoriesList,
  ResourceCard,
} from "./styles"
import { Row, Col } from "react-bootstrap"

const ResourceListing = ({ item }) => {
  // get page data
  const data = useStaticQuery(RESOURCES_QUERY)

  // set up state active category for initial load
  const [activeCategory, setActiveCategory] = useState(
    data.categories.edges[0].node.customFields.category
  )

  // filter results to whatever matches the active category
  const results = data.resources.edges.filter(
    resource =>
      resource.node.linkedContent_category.customFields.category ===
      activeCategory
  )

  // set up visible resource items
  const [visible, setVisible] = useState(9)

  // function to show more items
  const showMoreItems = () => {
    setVisible(prevValue => prevValue + 9)
  }

  // function to truncate text
  const truncate = (str, num) => {
    if (str.length > num) {
      return str.slice(0, num) + "..."
    }
    return str
  }

  return (
    <ResourcesContainer>
      <Wrapper>
        <h1>{item.customFields.title}</h1>
        <CategoriesList>
          {data.categories.edges.map((category, i) => {
            return (
              <li key={i}>
                <button
                  className={
                    activeCategory === category.node.customFields.category
                      ? "active"
                      : ""
                  }
                  onClick={() => {
                    setVisible(9)
                    setActiveCategory(category.node.customFields.category)
                  }}
                  onKeyDown={() => {
                    setVisible(9)
                    setActiveCategory(category.node.customFields.category)
                  }}
                >
                  {category.node.customFields.category}
                </button>
              </li>
            )
          })}
        </CategoriesList>
        <Row>
          {results.slice(0, visible).map((result, i) => (
            <React.Fragment key={i}>
              {result.node.customFields.link ? (
                <Col lg={4} md={6}>
                  <a
                    href={result.node.customFields.link.href}
                    title={result.node.customFields.link.label}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ResourceCard>
                      <h5>{truncate(result.node.customFields.title, 90)}</h5>
                      <p>Read More</p>
                    </ResourceCard>
                  </a>
                </Col>
              ) : null}
            </React.Fragment>
          ))}
        </Row>
        {results.length > visible && (
          <div className="load__more-container">
            <button className="load__more" onClick={showMoreItems}>
              Load More
            </button>
          </div>
        )}
      </Wrapper>
    </ResourcesContainer>
  )
}

const RESOURCES_QUERY = graphql`
  query {
    categories: allAgilityCategories {
      edges {
        node {
          customFields {
            category
          }
        }
      }
    }
    resources: allAgilityResources {
      edges {
        node {
          customFields {
            title
            link {
              href
              text
            }
          }
          linkedContent_category {
            customFields {
              category
            }
          }
        }
      }
    }
  }
`

export default ResourceListing
